export const API_URL = import.meta.env.VITE_API_URL;
export const MATCH_SOCKET_URL = import.meta.env.VITE_MATCH_SOCKET_URL;
export const SENTRY_DSN = import.meta.env.SENTRY_DSN;
